import axios from 'axios'

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

const token = localStorage.getItem(process.env.VUE_APP_TOKEN_NAME) || ''
if (token) {
    instance.defaults.headers.common[process.env.VUE_APP_TOKEN_NAME] = token
}

export default instance
